import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO, { SITE_URL } from '@/components/base/SEO';
import HeroSection from './components/HeroSection';
import FeatureGrid from './components/FeatureGrid';
import CategoryGrid from './components/CategoryGrid';
import CTASection from './components/CTASection';
import TestimonialSection from './components/TestimonialSection';
import AboutSection from './components/AboutSection';
import ArticleTeasers from './components/ArticleTeasers';

export default function Home() {
  return (
    <main>
      <SEO
        title="Litbuy Spreadsheet Guides, Reviews & Comparisons | LitbuySpreadsheets.online"
        description="Discover Litbuy Spreadsheet guides, reviews, comparisons, templates, and expert tips for e-commerce sellers. Learn how to use Litbuy Spreadsheet effectively to grow your online business."
        canonicalPath="/"
        keywords="litbuy spreadsheet, litbuy spreadsheet guide, litbuy spreadsheet review, litbuy spreadsheet download, litbuy spreadsheet template, spreadsheet tools, e-commerce spreadsheets"
        ogType="website"
        schemas={[
          {
            '@type': 'Organization',
            name: 'Litbuy Spreadsheets',
            url: SITE_URL,
            description: 'Litbuy Spreadsheet guides, reviews, comparisons, templates, and expert tips for e-commerce sellers and spreadsheet users.',
          },
          {
            '@type': 'WebSite',
            name: 'Litbuy Spreadsheets',
            url: SITE_URL,
            description: 'Litbuy Spreadsheet guides, reviews, comparisons, and expert tips for e-commerce sellers and spreadsheet users.',
            potentialAction: {
              '@type': 'SearchAction',
              target: `${SITE_URL}/search?q={search_term_string}`,
              'query-input': 'required name=search_term_string',
            },
          },
          {
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: 'Home', item: SITE_URL },
            ],
          },
        ]}
      />
      <Navbar />
      <HeroSection />
      <FeatureGrid />
      <CategoryGrid />
      <CTASection />
      <TestimonialSection />
      <AboutSection />
      <ArticleTeasers />
      <Footer />
    </main>
  );
}